import { render, staticRenderFns } from "./MatterDocumentList.vue?vue&type=template&id=5ab3b82b&"
import script from "./MatterDocumentList.vue?vue&type=script&lang=js&"
export * from "./MatterDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./MatterDocumentList.vue?vue&type=style&index=0&id=5ab3b82b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports